<template>
    <div class="form-popup" @click="clos()">
      <div class="form-container" @click.stop="">
        <div class="error-popup" v-show="incompleteData">
          <i class="ik ik-alert-triangle"></i>
          <span>
            {{ customErrorMsg }}
          </span>
        </div>
        <div class="form-header">
          <span> Mode eau </span>
          <i class="ik ik-x clos" @click="clos()"></i>
        </div>
        <div class="form-main">
            <span v-if="occupation.modeEau == 'index'">Faire passer sur forfait</span>
            <span v-else>Faire passer sur index</span>
            <!-- {{ occupation.modeEau }} -->
          <div class="input-container">
            <div v-if="occupation.modeEau == 'index'">
                <div class="input-item">
                    <span>Montant de la charge en eau*</span>
                    <input
                        type="number"
                        min="0"
                        placeholder="Entrez le montant de la charge en eau"
                        v-model="body.montantChargeEau"
                    />
                </div>
            </div>
            <div v-else>
                <div class="input-item">
                    <span>Prix unitaire*</span>
                    <input
                        type="number"
                        min="0"
                        placeholder="Entrez le prix d'un indexe"
                        v-model="body.puEau"
                    />
                </div>
                <!-- <div class="input-item">
                    <span>Ancien index</span>
                    <input
                        type="number"
                        min="0"
                        placeholder="Entrez l'ancien index"
                        v-model="body.ancienIndexEau"
                    />
                </div>
                <div class="input-item">
                    <span>Nouvel index</span>
                    <input
                        type="number"
                        min="0"
                        placeholder="Entrez le nouvel index"
                        v-model="body.nouvelIndexEau"
                    />
                </div> -->
            </div>
            

            <div v-if="occupation.modeEau == 'index'">
                <span style="font-size: 15px;">Voulez-vous retirer l'index problématique ?</span> <br>  
                <input type="radio" name="indexToRemove" id="indexToRemove-oui" v-model="body.indexToRemove" :value="true">
                <label for="indexToRemove-oui">&nbsp;<span>Oui</span></label>
                
                &nbsp;&nbsp;
                <input type="radio" name="indexToRemove" id="indexToRemove-non" v-model="body.indexToRemove" :value="false"> 
                <label for="indexToRemove-non">&nbsp;<span>Non</span></label>
            </div>

              <div class="input-item">
                <span v-if="body.indexToRemove == true" style="font-size: 15px;">Indiquez la période de l'index à retirer</span>
                <span v-else style="font-size: 15px;">Indiquez la période pour la charge en eau</span>
                <DatePicker
                  v-model="body.periode"
                  placeholder="Sélectionnez une date"
                  format="dddd, DD MMMM YYYY"
                  valueType="YYYY-MM-DD"
                  class="w-100"
                  :clearable="false"
                />
              </div>
          </div>
        </div>
        <div class="form-footer">
          <div class="cancel" @click="clos()">
            <OutlinedDarkBtn buttonTitle="Annuler" />
          </div>
          <div class="validate" @click="submitModeEau()">
            <FullPinkBtn buttonTitle="Passer sur forfait"  v-if="occupation.modeEau == 'index'"/>
            <FullPinkBtn buttonTitle="Passer sur index" v-else/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import FullPinkBtn from "../atomic/fullPinkBtn.vue";
  import OutlinedDarkBtn from "../atomic/outlinedDarkBtn.vue";
  import DatePicker from "vue2-datepicker";
  const php = require("phpjs");
  
  export default {
    props: {
      idOccupation: { String, required: true },
      occupation: { Object, required: true },
    },
    components: {
      FullPinkBtn,
      OutlinedDarkBtn,
      DatePicker,
    },
    data: () => ({
      caution:{
          type:'loyer',
          etat:'non reglée',
          date:null,
          montant:0,
      },
      body: {
        montantChargeEau: 0,
        puEau: 0,
        periode: dayjs().format("YYYY-MM-DD"),
        indexToRemove: false,
      },
      incompleteData: false,
      customErrorMsg: "Une erreur est survenue",
      
    }),
    computed: {
      ...mapGetters(["user", "hasAccess"]),
      canGenerateCharges() {
        return this.hasAccess("generate_charge_occupation");
      },
    },
    methods: {
      clos() {
        this.$emit("close");
      },
      submitModeEau() {
        if (this.body.indexToRemove == true && php.empty(this.body.periode)) {
          // this.customErrorMsg = 'Veuillez renseigner la periode';
          //     this.incompleteData = true;
          //     setTimeout(() => {
          //       this.incompleteData = false;
          //     }, 2000);
          return App.error("Vous devez spécifier la periode");
        }
        if (this.body.montantChargeEau == 0 && this.occupation.modeEau == "index") {
          // this.customErrorMsg = 'Vous devez spécifier un montant pour la charge en eau: '+this.body.montantChargeEau;
          //     this.incompleteData = true;
          //     setTimeout(() => {
          //       this.incompleteData = false;
          //     }, 2000);
          return App.error("Vous devez spécifier un montant pour la charge en eau");
        }
        this.body.modeEau = this.occupation.modeEau;
        this.$axios
          .put(
            "occupations/" + this.idOccupation + "/change-mode-eau",
            this.body
          )
          .then((response) => {
            // this.$emit("caution-added", response.result);
            this.clos();
            return App.notifySuccess(response.message);
          })
          .catch((error) => {
          //   notif.error(error.message);
            // this.customErrorMsg = error.message;
            //   this.incompleteData = true;
            //   setTimeout(() => {
            //     this.incompleteData = false;
            //   }, 2000);
            return App.error(error.message);
          });
        
      },
    },
    mounted() {
    },
  };
  </script>
  
  <style scoped>
  .form-popup {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    animation: appear2 0.35s;
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    z-index: 1500;
    cursor: pointer;
  }
  @keyframes appear2 {
    0% {
      transform: scale(1.1);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .form-popup .form-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 70%;
    max-height: 440px;
    width: 350px;
    max-width: 500px;
    background: white;
    border-radius: 8px;
    cursor: auto;
  }
  .form-container .form-header {
    padding: 0 5%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #eee;
  }
  .form-header span {
    font-weight: 600;
    font-size: 1.3rem;
  }
  .form-header .clos {
    font-size: 1.4rem;
    color: #191c22;
    cursor: pointer;
  }
  .form-container .form-footer {
    padding: 0 5%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 80px;
    border-top: 1px solid #eee;
  }
  .form-container .form-main {
    padding: 5%;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 150px);
  }
  .form-container .error-popup {
    padding-right: 10px;
    position: absolute;
    bottom: 100px;
    left: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    width: 90%;
    border-radius: 8px;
    background: white;
    animation: appear 0.3s;
    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.12);
  }
  .error-popup i {
    margin: 0 15px;
    font-size: 1.5rem;
  }
  .error-popup span {
    text-align: left;
    font-size: 0.9rem;
    font-weight: 500;
  }
  @keyframes appear {
    0% {
      transform: translateY(30px);
      box-shadow: none;
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
      box-shadow: 0 20px 20px rgba(0, 0, 0, 0.12);
    }
  }
  .input-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
  }
  .form-main span {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }
  .input-container .input-item {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100%;
  }
  .input-item > span {
    margin-bottom: 5px;
    font-size: 1rem;
    font-weight: 600;
  }
  .input-item input,
  .input-item select {
    padding: 0 5px;
    height: 45px;
    width: 100%;
    border: 1px solid #eee;
    border-radius: 8px;
    outline: none;
    background: transparent;
  }
  .input-item select option {
    padding: 10px 0;
    /* height: 45px; */
  }
  .validate {
    width: calc(60% - 5px);
  }
  .cancel {
    width: calc(40% - 5px);
  }
  </style>